document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".about-collection__toggle").forEach(function(btn) {
    btn.addEventListener("click", function () {
      const target = document.getElementById(this.dataset.target);
      target.classList.toggle("active");

      this.textContent = target.classList.contains("active")
        ? "View Less"
        : "View More";
    });
  });
});